import { type ChangeEvent, type Ref, forwardRef } from 'react';
import {
  ACCEPTED_FILE_FORMATS,
  validateFileFormat,
  validateFileNameChars,
  validateFileSize,
} from '../../../utils/fileValidator';

interface Props {
  onSubmit: (file: File) => void;
  onValidate: (isValid: boolean) => void;
}
const UploadFileForm = forwardRef(
  ({ onSubmit, onValidate }: Props, ref: Ref<HTMLInputElement>) => {
    const validate = (file: File): boolean => {
      const validateResult =
        validateFileFormat(file.name, file.type) &&
        validateFileNameChars(file.name) &&
        validateFileSize(file.size);
      onValidate(validateResult);
      return validateResult;
    };

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        const validateResult = validate(file);
        if (validateResult) {
          onSubmit(file);
        }
      }
      event.target.value = '';
    };

    return (
      <form>
        <input
          data-testid="file-input"
          name="File"
          type="file"
          style={{ display: 'none' }}
          ref={ref}
          onChange={onChange}
          accept={ACCEPTED_FILE_FORMATS.join(',')}
          value=""
        />
      </form>
    );
  },
);

export default UploadFileForm;
